import { SetState, GetState } from 'zustand';

export interface IStatementsListSlice {
  statementsData: any;
  setStatementsData: (statementsData: any) => void;
  getStatementsData: () => { statementsData: any };
  resetStatementsListSlice: () => void;
}

const createStatementsListSlice = (set: SetState<IStatementsListSlice>, get: GetState<IStatementsListSlice>) => ({
  statementsData: {},
  setStatementsData: (statementsData: any) => {
    set({ statementsData });
  },
  getStatementsData: () => get().statementsData,
  resetStatementsListSlice: () => {
    set({ statementsData: {} });
  },
});
export default createStatementsListSlice;
